<script setup>
import { ref } from "vue";

import AppSubMenu from "./AppSubMenu.vue";

const topModel = ref([
  {
    label: "Build",
    items: [
      {
        label: "Automations",
        icon: "WebhookIcon",
        to: "/automations",
      },
      {
        label: "Flows",
        icon: "FlowIcon",
        to: "/flows",
      },
      {
        label: "Integrations",
        icon: "pi pi-fw pi-share-alt",
        to: "/integrations",
      },
    ],
  },
]);

const bottomModel = ref([
  {
    items: [
      {
        label: "Join discord",
        icon: "pi pi-fw pi-discord",
        url: "https://discord.gg/H2z2Qugu",
      },
      {
        label: "Get in touch",
        icon: "TalkToFounderIcon",
        url: "https://cal.com/lennertneena/30min",
      },
    ],
  },
]);
</script>

<template>
  <AppSubMenu :top-model="topModel" :bottom-model="bottomModel" />
</template>

<style lang="scss" scoped></style>
